import { AppBrandContextProvider } from '../app-brand/app-brand-context-provider';
import { UnauthedModalPortalContextProvider } from '../contexts/modal-context/unauthed-modal-portal';
import { IntlProvider } from '../intl/intl-provider';
import { UnauthenticatedLocaleContextProvider } from '../intl/locale-context-provider/unauthenticated-locale-context-provider';
import { Provider as PortalProvider } from '../portals/context';
import { Provider as HotkeyProvider } from '../ui-components/components/hotkey/context';
import ModalManagerPortal from '../portals/modal-manager';

import type React from 'react';

type AuthPageProviderProps = {
  children: React.ReactNode;
};

export const AuthPageProvider = ({ children }: AuthPageProviderProps) => {
  return (
    <UnauthenticatedLocaleContextProvider>
      <AppBrandContextProvider>
        <IntlProvider>
          <HotkeyProvider>
            {children}
            <PortalProvider>
              <UnauthedModalPortalContextProvider>
                <ModalManagerPortal />
              </UnauthedModalPortalContextProvider>
            </PortalProvider>
          </HotkeyProvider>
        </IntlProvider>
      </AppBrandContextProvider>
    </UnauthenticatedLocaleContextProvider>
  );
};
